export enum ClientReferralTaskStatus {
  open = 'open',
  sleeping = 'sleeping',
  closed = 'closed',
}
